import React, { useEffect } from 'react';
import NavBar from '../Main/NavBar';
import { useLocation } from 'react-router-dom';

const OrderConfirmation = () => {
  const location = useLocation();
  const { orderId, method, amount } = location.state || {};

  useEffect(() => {
    // Csak akkor trackeljünk, ha van rendelésazonosító
    if (!orderId) return;

    const transactionId = orderId;

    const alreadyTracked = sessionStorage.getItem('purchase_tracked');
    if (alreadyTracked === transactionId) return;

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: 'adkkez_visszig_Fizetés',
      value: Number(amount) || 0,
      transaction_id: transactionId,
      currency: 'HUF'
    });

    sessionStorage.setItem('purchase_tracked', transactionId);
  }, [orderId, amount]);

  return (
    <div>
      <NavBar />

      <div className="payment-review">
        <h1>Sikeres Rendelés!</h1>
        <h2>Rendelés azonosító: {orderId}</h2>

        {method === 'banktransfer' && (
          <div>
            <p>
              Kérjük, hogy az összeget a
              12094507-01372320-00100009 számlaszámra küldje el az alábbi
              módon:
            </p>

            <ul>
              <li>Kedvezményezett: Dentalcoop Plus Kft.</li>
              <li>Számlaszám: 12094507-01372320-00100009</li>
              <li>Összeg: {amount}</li>
              <li>Közlemény: Rendelés azonosító: {orderId}</li>
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default OrderConfirmation;
